import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Companies from "@/pages/Companies";
import Shareholders from "@/pages/Shareholders";
import CreateDividend from "@/pages/CreateDividend";
import DividendHistory from "@/pages/DividendHistory";
import DividendDetail from "@/pages/DividendDetail";
import Users from "@/pages/Users";
import Audit from "@/pages/Audit";

function Protected({ children, adminOnly }) {
  return (
    <ProtectedRoute adminOnly={adminOnly}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/companies" element={<Protected><Companies /></Protected>} />
            <Route path="/shareholders" element={<Protected><Shareholders /></Protected>} />
            <Route path="/create-dividend" element={<Protected><CreateDividend /></Protected>} />
            <Route path="/history" element={<Protected><DividendHistory /></Protected>} />
            <Route path="/dividends/:id" element={<Protected><DividendDetail /></Protected>} />
            <Route path="/users" element={<Protected adminOnly><Users /></Protected>} />
            <Route path="/audit" element={<Protected adminOnly><Audit /></Protected>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
